export { GenerarContrarecibosModalEdit, Props } from "./modal";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibos/index.tsx